import { CONSTANTS, HELPERS } from '@/utils';
import { useEffect, useState } from 'react';

const getItemTitle = (title, payload) => {
  if (!payload) {
    return title || 'Item';
  }

  if (payload.purchasable_type === CONSTANTS.PRODUCT_TYPE.EVENT.id) {
    return `Pembelian Event - ${title}`;
  }

  const { label } = HELPERS.typeOfPurchasable(payload.purchasable_type);
  let itemTitle = `${label} ${title}`;
  if (payload.subscribeable_title != null) {
    itemTitle = `${itemTitle} ${itemTitle.indexOf('Program Belajar') === -1 ? ' - Program Belajar' : ''} ${
      payload.subscribeable_title
    }`;
  }
  return itemTitle;
};

function PriceList({ items, typePurchase, payload }) {
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (items?.length > 0) {
      setTotal(items.reduce((acc, item) => acc + item.value, 0));
    }
  }, [items]);

  if (!items || !payload) return null;

  return (
    <div className="w-full">
      <div className="rounded-2xl overflow-hidden text-sm text-gray-700">
        {/* Items List */}
        <div className="flex flex-col">
          {items.map((item, index) => (
            <div
              key={`${item.title}-${index}`}
              className={`flex justify-between font-semibold bg-gray-100 p-4 ${index === 0 ? 'pt-4' : 'pt-0'}`}
            >
              <div className="flex-1">{getItemTitle(item.title, payload)}</div>
              <div className={`text-right text-base ${item.value < 0 ? 'text-red-500' : ''}`}>
                {item.value < 0
                  ? `- Rp ${HELPERS.numberFormat(Math.abs(item.value))}`
                  : `Rp ${HELPERS.numberFormat(item.value)}`}
              </div>
            </div>
          ))}
        </div>

        {/* Total */}
        <div className="flex justify-between bg-gray-100 p-4 pt-4 border-t">
          <div className="font-semibold">Total</div>
          <div className="text-right font-bold text-lg min-w-[140px]">
            {total > 0 ? `Rp ${HELPERS.numberFormat(Math.abs(total))}` : 'GRATIS'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PriceList;
